import School from "../../../models/School";
import React, { Component, Fragment } from "react";
import DispatchProps from "../../../utils/DispatchProps";
import Actions from "../../../redux/Actions";
import OnboardHelpBox from "./OnboardHelpBox";
import OnboardTimeline, {OnboardTimelineItem} from "./OnboardTimeline";
import { IRootState } from "../../../store";
import { connect } from "react-redux";
import { History } from "history";
import ApiService from "../../ApiService";
import {MessageBarType} from "office-ui-fabric-react";
import {SchoolWorkloadConfig} from "../../../models/SchoolWorkloadConfig";
import SyncSubjectsAndYearsPrompt from "../../SyncSubjectsAndYearsPrompt";
import SubjectExcludeEditor from "./SubjectExcludeEditor";
import SdsSubject from "../../../models/SdsSubject";
import LoadingPage from "../../LoadingPage";
import OnboardNavigation from "./OnboardNavigation";

interface OnboardSubjectExcludePageProps {
    tenantId: string;
    schoolCode: string;
    apiService: ApiService;
    history: History;
}

interface OnboardSubjectExcludePageState {
    school?: School;
    schoolWorkloadConfig?: SchoolWorkloadConfig;
    sdsSubjects?: SdsSubject[];
}

class OnboardSubjectExcludePage extends Component<OnboardSubjectExcludePageProps & DispatchProps, OnboardSubjectExcludePageState> {

    constructor(props: OnboardSubjectExcludePageProps & DispatchProps) {
        super(props);
        this.state = {
            school: undefined,
            schoolWorkloadConfig: undefined,
            sdsSubjects: undefined
        };
    }

    async componentDidMount(): Promise<void> {

        if (this.props.tenantId && this.props.schoolCode)
        {
            await this.load();
        }
    }

    async componentDidUpdate(prevProps: Readonly<OnboardSubjectExcludePageProps & DispatchProps>, prevState: OnboardSubjectExcludePageState): Promise<void> {
        if (this.props.tenantId !== prevProps.tenantId || this.props.schoolCode !== prevProps.schoolCode)
        {
            await this.load();
        }
    }

    private async load(): Promise<void> {
        const school = await this.props.apiService.getSchool(this.props.tenantId, this.props.schoolCode)
        const schoolWorkloadConfig = await this.props.apiService.getSchoolConfigJson(this.props.tenantId,this.props.schoolCode);
        const sdsSubjects = await this.props.apiService.getSdsSubjectsForSchool(this.props.tenantId,this.props.schoolCode);

        this.setState({
            school,
            schoolWorkloadConfig,
            sdsSubjects
        });
    }
    
    private save = async (): Promise<boolean> => {
        if(this.state.schoolWorkloadConfig === undefined)
        {
            return false;
        }
        
        const savedSchoolWorkloadConfig = await this.props.apiService.putSchoolConfigJson(this.props.tenantId,this.props.schoolCode,this.state.schoolWorkloadConfig);
        
        this.setState({
            schoolWorkloadConfig: savedSchoolWorkloadConfig
        });

        await this.props.dispatch(Actions.showMessageBar("Saved subject excludes to config",MessageBarType.success));
        
        return true;
    }

    public render(): JSX.Element {
        
        if(this.state.school === undefined || this.state.schoolWorkloadConfig === undefined || this.state.sdsSubjects === undefined)
        {
            return <LoadingPage/>;
        }
        
        return (
            <Fragment>
                {this.state.school ? <SyncSubjectsAndYearsPrompt school={this.state.school} message={"SyncSubjectsAndYears must have completed for subjects to appear."}/> : null }


                <OnboardHelpBox currentTimelineItemKey={"subject-exclude"}/>
                <OnboardTimeline tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} apiService={this.props.apiService}>
                    {(school: School,timelineItems: OnboardTimelineItem[]) => {
                        return (
                            <Fragment>
                                <SubjectExcludeEditor schoolWorkloadConfig={this.state.schoolWorkloadConfig!} sdsSubjects={this.state.sdsSubjects!} onChange={(updatedConfig) =>{
                                    this.setState({
                                        schoolWorkloadConfig: updatedConfig
                                    });
                                }}/>
                                
                                <OnboardNavigation currentTimelineItemKey={"subject-exclude"} timelineItems={timelineItems} completeItem={this.save}
                                                   enableNext={true} enableSave={true} history={this.props.history}
                                                   tenantId={this.props.tenantId} schoolCode={this.props.schoolCode}/>
                            </Fragment>
                        );
                    }}
                </OnboardTimeline>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: any): OnboardSubjectExcludePageProps => {
        return {
            tenantId: ownProps.match.params.tenantId,
            schoolCode: ownProps.match.params.schoolCode,
            apiService: state.auth.apiService,
            history: ownProps.history
        };
    }
)(OnboardSubjectExcludePage)